import { Outlet } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';

export function NoveltiesPage(): ReactElement {
  return (
    <BrandSidebarWithHeader fullWidth={true}>
      <Outlet />
    </BrandSidebarWithHeader>
  );
}
